(() => {
  const root = document.getElementById('iphone-guide');
  if (!root || root.dataset.guideDemo) return;
  const area = root.querySelector('.ypd-topic-area');
  const tiles = [...root.querySelectorAll('.ypd-topics > li')];
  const templates = [...root.querySelectorAll('template[data-ypd-content]')];
  if (!area || tiles.length !== 6 || templates.length !== 6) return;
  // Full approved Mountain guidance, including original subsection headings.
  const states = tiles.map((tile, index) => ({
    title: tile.querySelector('span').textContent.trim(),
    template: templates.find(t => t.dataset.ypdContent === String(index))
  }));
  if (states.some(s => !s.template)) return;
  root.dataset.guideDemo = 'ready';
  const panel = document.createElement('section');
  panel.className = 'guide-demo-panel';
  panel.setAttribute('aria-label', 'Guidance included for each pose');
  panel.setAttribute('aria-live', 'off');
  const header = document.createElement('div'); header.className = 'guide-demo-panel-header';
  const title = document.createElement('h4'); title.className = 'guide-demo-title';
  const toggle = document.createElement('button'); toggle.className = 'guide-demo-toggle'; toggle.type = 'button';
  const copy = document.createElement('div'); copy.className = 'guide-demo-copy';
  header.append(title, toggle); panel.append(header, copy); area.append(panel);
  const motion = matchMedia('(prefers-reduced-motion: reduce)');
  let index = 0, visible = false, userPaused = false, explicitlyResumed = false, timer = 0, transitionTimer = 0;
  const allowed = () => visible && !document.hidden && !userPaused && (!motion.matches || explicitlyResumed);
  const stop = () => { clearTimeout(timer); clearTimeout(transitionTimer); timer = 0; transitionTimer = 0; tiles.forEach(t => t.classList.remove('is-demo-tapping')); };
  const updateButton = () => {
    const paused = userPaused || (motion.matches && !explicitlyResumed);
    toggle.setAttribute('aria-label', paused ? 'Resume demo' : 'Pause demo');
    toggle.title = paused ? 'Resume demo' : 'Pause demo';
    toggle.innerHTML = paused ? '<svg aria-hidden="true" viewBox="0 0 12 12"><path d="m3 1 8 5-8 5Z"/></svg>' : '<svg aria-hidden="true" viewBox="0 0 12 12"><path d="M2 1h3v10H2zm5 0h3v10H7z"/></svg>';
  };
  const render = (next, animate) => {
    index = next;
    tiles.forEach((tile, i) => { tile.classList.toggle('is-demo-active', i === index); if (i === index) tile.setAttribute('aria-current', 'true'); else tile.removeAttribute('aria-current'); });
    title.textContent = states[index].title;
    copy.replaceChildren(states[index].template.content.cloneNode(true));
    copy.classList.remove('is-demo-entering');
    if (animate && !motion.matches) { void copy.offsetWidth; copy.classList.add('is-demo-entering'); }
    root.dataset.guideDemoIndex = String(index);
  };
  const schedule = () => {
    stop(); updateButton();
    if (!allowed()) return;
    timer = setTimeout(() => {
      if (!allowed()) return;
      const next = (index + 1) % states.length;
      if (!motion.matches) tiles[next].classList.add('is-demo-tapping');
      transitionTimer = setTimeout(() => { if (!allowed()) return; render(next, true); schedule(); }, motion.matches ? 0 : 300);
    }, 6000);
  };
  toggle.addEventListener('click', () => {
    if (userPaused || (motion.matches && !explicitlyResumed)) { userPaused = false; explicitlyResumed = true; }
    else userPaused = true;
    schedule();
  });
  tiles.forEach((tile, i) => {
    tile.setAttribute('role', 'button');
    tile.tabIndex = 0;
    const select = () => { userPaused = true; stop(); render(i, false); updateButton(); copy.scrollTop = 0; };
    tile.addEventListener('click', select);
    tile.addEventListener('keydown', event => {
      if (event.key === 'Enter' || event.key === ' ') { event.preventDefault(); select(); }
    });
  });
  new IntersectionObserver(entries => { visible = entries[0].isIntersecting; schedule(); }, { threshold: .15 }).observe(root.querySelector('.iphone-shell'));
  document.addEventListener('visibilitychange', schedule);
  motion.addEventListener('change', () => { explicitlyResumed = false; if (motion.matches) render(0, false); schedule(); });
  render(0, false); updateButton();
})();
